import { styled } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

/* be careful about modifying the style of this file,
  as it is consistent with the style of the declarations page.
  src/components/DeclarationForm/DeclarationFormFinalStep/FinalStepOverview/Overview/styles.ts
*/

export const StyledProductsContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    width: '100%',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    padding: theme.spacing(0, 1),
  }),
);

export const StyledProductContainer = styled('div')(
  ({
    theme,
    backgroundColor,
    fontColor,
    isItalicStyleText,
  }: {
    theme: ICustomTheme;
    backgroundColor?: string;
    fontColor?: string;
    isItalicStyleText?: boolean;
  }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
    borderBottom: backgroundColor
      ? 'none'
      : `1px solid ${theme.colors.grey.light3}`,
    backgroundColor: backgroundColor || theme.colors.white,
    color: fontColor || theme.colors.grey.dark,
    fontStyle: isItalicStyleText ? 'italic' : 'normal',
  }),
);

export const StyledProductInfo = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexWrap: 'wrap',
    paddingLeft: theme.spacing(2),
    width: '50%',
  }),
);

export const StyledPagination = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  }),
);
